var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts",style:(_vm.schema.graphic.style),attrs:{"id":_vm.schema.model}})
}
var staticRenderFns = []

export { render, staticRenderFns }